import { render } from "./QuestionThree.vue?vue&type=template&id=42c953ae&scoped=true"
import script from "./QuestionThree.vue?vue&type=script&lang=js"
export * from "./QuestionThree.vue?vue&type=script&lang=js"

import "./QuestionThree.vue?vue&type=style&index=0&id=42c953ae&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c953ae"]])

export default __exports__